import { Injectable } from '@angular/core';
import { AppConfig } from '../models/config.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig;

  constructor() {
    // Check for runtime config first (container), fallback to environment (local dev)
    this.config = window.appConfig || environment;
    
    console.log('Config loaded from:', window.appConfig ? 'runtime (container)' : 'environment (local dev)');
  }

  get production(): boolean {
    return this.config.production;
  }

  get msalConfig() {
    return this.config.msalConfig;
  }

  get apiConfig() {
    return this.config.apiConfig;
  }

  get clientId(): string {
    return this.config.msalConfig.auth.clientId;
  }

  get authority(): string {
    return this.config.msalConfig.auth.authority;
  }

  get redirectUri(): string {
    return this.config.msalConfig.auth.redirectUri;
  }

  get postLogoutRedirectUri(): string {
    return this.config.msalConfig.auth.postLogoutRedirectUri;
  }

  get cacheLocation(): 'localStorage' | 'sessionStorage' {
    return this.config.msalConfig.cache.cacheLocation;
  }

  get storeAuthStateInCookie(): boolean {
    return this.config.msalConfig.cache.storeAuthStateInCookie;
  }

  get scopes(): string[] {
    return this.config.apiConfig.scopes;
  }

  get apiUri(): string {
    return this.config.apiConfig.uri;
  }

  get graphScopes(): string[] {
    return this.config.graphScopes;
  }

  get baseHref(): string {
    return this.config.baseHref;
  }

  get vtkUrl(): string {
    return this.config.vtkUrl;
  }

  get serviceWorkerEnabled(): boolean {
    return this.config.serviceWorker?.enabled || false;
  }

  get updateCheckInterval(): number {
    return this.config.serviceWorker?.updateCheckInterval || 60000;
  }
}